export enum MaritalStatus {
    Single,
	Married
}